module.exports = __webpack_public_path__ + "img/Weapon_251.44e81d22.png";